import React, { useState } from 'react';
import { ShieldCheck, CheckCircle2, Lock, Download, Shield, HeadphonesIcon, ChevronDown, Mail } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Countdown } from './Countdown';
export function TrustSection() {
  const [openFaq, setOpenFaq] = useState<number>(0);
  const checkoutUrl = 'https://pay.hotmart.com/X104283580R?checkoutMode=10';
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const faqs = [{
    q: '¿En qué formato recibo el recetario?',
    a: 'Recibís todo en PDF de alta calidad, listo para descargar en tu celular, tablet o computadora. También podés imprimirlo si querés tenerlo en papel.'
  }, {
    q: '¿Necesito experiencia previa en repostería?',
    a: 'No. Las recetas están explicadas paso a paso, con fotos y consejos para principiantes. Si sabés prender el horno, podés hacer estos budines.'
  }, {
    q: '¿Las recetas funcionan con horno común y eléctrico?',
    a: 'Sí. Cada receta incluye temperaturas y tiempos para ambos tipos de horno, y tips para detectar el punto exacto de cocción.'
  }, {
    q: '¿Puedo realmente vender estos budines?',
    a: 'Sí. La guía de venta te enseña a calcular precios rentables, presentar el producto, conseguir clientes y manejar pedidos. Muchas alumnas ya están vendiendo.'
  }, {
    q: '¿Qué pasa si no me gusta el producto?',
    a: 'Tenés 45 días de garantía. Si no estás conforme, te devolvemos el 100% del dinero sin preguntas.'
  }];
  return <>
      {/* 13. Garantía */}
      <section className="py-20 px-4 bg-[#FAF6F0]" data-id="element-265">
        <div className="max-w-4xl mx-auto" data-id="element-266">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden relative" data-id="element-267">
            <div className="absolute top-0 right-0 w-64 h-64 bg-violet-200 rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-268" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-green-100 rounded-full blur-3xl opacity-50 translate-y-1/2 -translate-x-1/2" data-id="element-269" />

            <div className="relative p-8 md:p-12 flex flex-col md:flex-row items-center gap-10" data-id="element-270">
              <div className="w-full md:w-1/3 flex justify-center" data-id="element-271">
                <div className="relative w-48 h-48 flex items-center justify-center" data-id="element-272">
                  <div className="absolute inset-0 border-4 border-dashed border-violet-300 rounded-full animate-[spin_20s_linear_infinite]" data-id="element-273" />
                  <div className="absolute inset-2 bg-gradient-to-br from-violet-400 to-violet-600 rounded-full flex flex-col items-center justify-center text-white shadow-lg" data-id="element-274">
                    <ShieldCheck className="w-12 h-12 mb-2" data-id="element-275" />
                    <span className="font-black text-center leading-tight" data-id="element-276">
                      45 DÍAS
                      <br data-id="element-277" />
                      DE GARANTÍA
                    </span>
                  </div>
                </div>
              </div>

              <div className="w-full md:w-2/3" data-id="element-278">
                <h2 className="text-3xl font-bold text-violet-900 mb-4" data-id="element-279">
                  Garantía de Satisfacción 100%
                </h2>
                <p className="text-stone-600 mb-6" data-id="element-280">
                  Estamos tan seguros de la calidad de nuestras recetas que te
                  damos 45 días para probarlas. Si hacés los budines y no te
                  gustan los resultados, te devolvemos tu dinero.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-281">
                  {['Sin riesgo para vos', 'Reembolso completo del 100%', 'Sin hacer preguntas', 'Trámite simple por email'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-282">
                      <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-283" />
                      <span className="text-stone-800 font-medium" data-id="element-284">{item}</span>
                    </div>)}
                </div>
                <button onClick={scrollToOffer} className="bg-violet-600 hover:bg-violet-700 text-white font-bold py-3 px-8 rounded-xl shadow-md transition-colors" data-id="element-285">
                  Probalo sin riesgo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 14. Trust Bar */}
      <section className="bg-white border-y border-stone-200 py-12 px-4" data-id="element-286">
        <div className="max-w-6xl mx-auto" data-id="element-287">
          <div className="text-center mb-10" data-id="element-288">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-289">
              <Lock className="w-6 h-6 text-green-600" data-id="element-290" />
              <h2 className="text-2xl font-bold text-violet-900" data-id="element-291">
                Transacción 100% Segura
              </h2>
            </div>
            <p className="text-stone-500" data-id="element-292">
              Tu compra está protegida por la plataforma de pagos más segura
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mb-10" data-id="element-293">
            {[{
            icon: Lock,
            title: 'Pago Seguro',
            desc: 'Encriptación SSL 256-bit'
          }, {
            icon: ShieldCheck,
            title: 'Garantía 100%',
            desc: '45 días de prueba'
          }, {
            icon: Download,
            title: 'Acceso Inmediato',
            desc: 'Descarga al instante'
          }, {
            icon: Shield,
            title: 'Privacidad Protegida',
            desc: 'Datos personales a salvo'
          }, {
            icon: HeadphonesIcon,
            title: 'Soporte Dedicado',
            desc: 'Asistencia por email'
          }].map((item, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-294">
                <div className="bg-violet-50 p-4 rounded-full mb-3" data-id="element-295">
                  <item.icon className="w-6 h-6 text-violet-600" data-id="element-296" />
                </div>
                <h4 className="font-bold text-violet-900 text-sm mb-1" data-id="element-297">
                  {item.title}
                </h4>
                <p className="text-xs text-stone-500" data-id="element-298">{item.desc}</p>
              </div>)}
          </div>

          <div className="border-t border-stone-100 pt-8 flex justify-center gap-4 flex-wrap opacity-60 grayscale" data-id="element-299">
            <div className="w-12 h-8 bg-blue-900 rounded flex items-center justify-center text-white text-xs font-bold italic" data-id="element-300">
              VISA
            </div>
            <div className="w-12 h-8 bg-gradient-to-br from-red-500 to-orange-500 rounded flex items-center justify-center text-white text-xs font-bold" data-id="element-301">
              MC
            </div>
            <div className="w-16 h-8 bg-blue-100 rounded flex items-center justify-center text-blue-900 text-xs font-bold italic" data-id="element-302">
              PayPal
            </div>
            <div className="w-12 h-8 bg-blue-500 rounded flex items-center justify-center text-white text-xs font-bold" data-id="element-303">
              AMEX
            </div>
            <div className="w-16 h-8 bg-black rounded flex items-center justify-center text-white text-xs font-bold" data-id="element-304">
              Pay
            </div>
          </div>
        </div>
      </section>

      {/* 15. FAQ */}
      <section className="py-20 px-4 bg-[#FAF6F0]" data-id="element-305">
        <div className="max-w-3xl mx-auto" data-id="element-306">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-violet-900 mb-12" data-id="element-307">
            Preguntas frecuentes
          </h2>

          <div className="space-y-4" data-id="element-308">
            {faqs.map((faq, i) => <div key={i} className="bg-white rounded-2xl shadow-sm border border-stone-100 overflow-hidden" data-id="element-309">
                <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenFaq(openFaq === i ? -1 : i)} data-id="element-310">
                  <span className="font-bold text-violet-900 pr-4" data-id="element-311">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-violet-500 transition-transform duration-300 flex-shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-312" />
                </button>
                <AnimatePresence data-id="element-313">
                  {openFaq === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-314">
                      <div className="px-6 pb-5 text-stone-600" data-id="element-315">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </section>

      {/* 16. CTA Final */}
      <section className="py-24 px-4 bg-violet-900 text-center" data-id="element-316">
        <div className="max-w-3xl mx-auto" data-id="element-317">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8" data-id="element-318">
            Empezá hoy a hacer budines perfectos
          </h2>
          <div className="flex justify-center mb-10" data-id="element-319">
            <Countdown variant="light" data-id="element-320" />
          </div>
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="inline-block bg-green-500 hover:bg-green-600 text-white text-xl md:text-2xl font-bold py-5 px-12 rounded-full shadow-[0_0_30px_rgba(34,197,94,0.4)] transition-all animate-pulse" data-id="element-321">
            COMPRAR AHORA
          </a>
        </div>
      </section>

      {/* 17. Footer */}
      <footer className="bg-stone-900 text-stone-400 py-16 px-4" data-id="element-322">
        <div className="max-w-6xl mx-auto" data-id="element-323">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-324">
            <div data-id="element-325">
              <div className="flex items-center gap-2 mb-4 text-white" data-id="element-326">
                <Lock className="w-5 h-5" data-id="element-327" />
                <h4 className="font-bold" data-id="element-328">Pago Seguro</h4>
              </div>
              <p className="text-sm mb-4" data-id="element-329">
                Tus datos están protegidos con encriptación SSL de 256 bits.
                Transacción procesada por plataforma segura.
              </p>
              <div className="flex gap-2 flex-wrap opacity-50" data-id="element-330">
                <div className="w-10 h-6 bg-white rounded flex items-center justify-center text-blue-900 text-[10px] font-bold italic" data-id="element-331">
                  VISA
                </div>
                <div className="w-10 h-6 bg-white rounded flex items-center justify-center text-red-500 text-[10px] font-bold" data-id="element-332">
                  MC
                </div>
                <div className="w-12 h-6 bg-white rounded flex items-center justify-center text-blue-900 text-[10px] font-bold italic" data-id="element-333">
                  PayPal
                </div>
              </div>
            </div>

            <div data-id="element-334">
              <h4 className="font-bold text-white mb-4" data-id="element-335">Enlaces útiles</h4>
              <ul className="space-y-2 text-sm" data-id="element-336">
                <li data-id="element-337">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-338">
                    Términos y Condiciones
                  </a>
                </li>
                <li data-id="element-339">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-340">
                    Política de Privacidad
                  </a>
                </li>
                <li data-id="element-341">
                  <a href="#" className="hover:text-white transition-colors" data-id="element-342">
                    Política de Cookies
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-343">
              <h4 className="font-bold text-white mb-4" data-id="element-344">Contactanos</h4>
              <div className="flex items-center gap-2 text-sm" data-id="element-345">
                <Mail className="w-4 h-4" data-id="element-346" />
                <a href="mailto:info@tudominio.com" className="hover:text-white transition-colors" data-id="element-347">
                  info@tudominio.com
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-stone-800 pt-8 text-xs text-center space-y-4" data-id="element-348">
            <p data-id="element-349">
              Este producto no garantiza la obtención de resultados. Cualquier
              referencia al desempeño de una estrategia no debe ser interpretada
              como una garantía de resultados.
            </p>
            <p data-id="element-350">
              © {new Date().getFullYear()} Mega-Pack Budines. Todos los
              derechos reservados.
            </p>
            <p className="opacity-60" data-id="element-351">
              Este sitio no es parte del sitio web de Facebook o Facebook Inc.
              Además, este sitio NO está respaldado por Facebook de ninguna
              manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
            </p>
          </div>
        </div>
      </footer>
    </>;
}